export var saveFailure = function saveFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to save your changes'),
    duration: 'medium'
  };
};